export const preloader = () => {

		return

    let preloader = document.querySelector('[data-preloader]')
    const isHomepage = document.querySelector('[data-namespace="home"]')

    if (!preloader || !isHomepage) return

    let logo = preloader.querySelector('[data-logo]'),
        logotype = preloader.querySelector('[data-logotype]'),
        group = preloader.querySelector('[data-group]')

    let tl = gsap.timeline()

    tl.fromTo(logo, {
        opacity: 0,
    }, {
        opacity: 1,
        duration: 0.6,
        ease: 'none',
    })

    tl.fromTo(logo, {
        x: '40%',
    }, {
        x: 0,
        duration: 0.6,
        ease: 'power2.out',
    }, '<')

    tl.fromTo(logotype, {
        x: '-115%',
    }, {
        x: 0,
        duration: 0.6,
        ease: 'power2.out',
    }, '<')

    tl.fromTo(group, {
        y: 0,
        opacity: 1,
    }, {
        y: '100%',
        opacity: 0,
        duration: 0.6,
        delay: 0.3,
        ease: 'power2.inOut',
    })

}

export default () => { }